import React from 'react';
import styles from './Social.module.scss';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Link from 'next/link';
import Icon from '@/components/UI/icon/Icon';
import TwitterxIcon from '@/components/icons/TwitterxIcon';
import LinkedinIcon from '@/components/icons/LinkedinIcon';
const socialItems = [{
  href: 'https://telegram.me/shab_ir',
  icon: <Icon name={'send-2-2'} type={'primary'} size={28} />
}, {
  href: 'https://twitter.com/shabhost',
  icon: <Box className={styles['icon-container']}>
        <TwitterxIcon />
      </Box>
}, {
  href: 'https://www.instagram.com/_shab.ir/',
  icon: <Icon name={'instagram'} type={'primary'} size={28} />
}, {
  href: 'https://www.linkedin.com/company/shab.ir',
  icon: <Box className={styles['icon-container']}>
        <LinkedinIcon />
      </Box>
}];
const Social = () => {
  return <Box className={styles['container']} data-sentry-element="Box" data-sentry-component="Social" data-sentry-source-file="Social.tsx">
      <Box className={styles['wrapper']} data-sentry-element="Box" data-sentry-source-file="Social.tsx">
        <Typography variant={'title'} component={'h5'} data-sentry-element="Typography" data-sentry-source-file="Social.tsx">
          شبکه‌های اجتماعی شب
        </Typography>
        <Box className={styles['social-media-items']} data-sentry-element="Box" data-sentry-source-file="Social.tsx">
          {socialItems.map((item, index) => {
          return <Link key={'SOCIAL_ICON_' + index} target="_blank" rel="noreferrer" className={styles['social-media-item']} href={item.href}>
                {item.icon}
              </Link>;
        })}
        </Box>
      </Box>
    </Box>;
};
export default Social;